import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type MonitorIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const MonitorIcon: React.FC<MonitorIconProps> = ({
  title = 'Storefront',
  viewBox = '0 0 24 24',
  ...props
}) => (
  <CreateIconComponent viewBox={viewBox} title={title} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.83334 1.66669C1.18902 1.66669 0.666687 2.18902 0.666687 2.83335V16.8358C0.666687 17.4801 1.18902 18.0025 1.83335 18.0025H10.9147V20.57H7.59344C6.94911 20.57 6.42678 21.0923 6.42678 21.7367C6.42678 22.381 6.94911 22.9033 7.59344 22.9033H12.0813H16.7418C17.3862 22.9033 17.9085 22.381 17.9085 21.7367C17.9085 21.0923 17.3862 20.57 16.7418 20.57H13.248V18.0025H22.1631C22.8074 18.0025 23.3298 17.4801 23.3298 16.8358V2.83335C23.3298 2.18902 22.8074 1.66669 22.1631 1.66669H1.83335ZM3.00002 15.6691V4.00002H20.9964V15.6691H3.00002Z"
    />
  </CreateIconComponent>
);

export default MonitorIcon;
